import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getTranslate, getActiveLanguage } from "react-localize-redux";
import { NavLink } from "react-router-dom";
import {
  Collapse,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  Spinner,
} from "reactstrap";
import axios from "axios";
import FileSaver from "file-saver";
import Select from "react-select";
import AnimateHeight from "react-animate-height";
import ReactTooltip from "react-tooltip";
import { actions } from "react-redux-form";
import {
  fileActions,
  documentActions,
  userActions,
  settingActions,
} from "../../../../../redux/actions";
import { TooltipWithAutoHide } from "../../../../../components";
import { handleErrors } from "../../../../../utils";
import logo2 from "../../../../../itell.svg.png";
import { SwitchUserButton } from "./SwitchUserButton";
import { AddIssueButton } from "./AddIssueButton";
class Topbar extends React.Component {
  state = {
    collapsed: false,
    settingsHeight: 0,
  };
  handleOutsideClick = (e) => {
    // ignore clicks on the component itself
    if (this.settingsContainerNode && this.settingsContainerNode.contains) {
      if (this.settingsContainerNode.contains(e.target)) {
        return;
      }
      this.toggleSettings();
    }
  };

  toggleSettings = () => {
    const { settingsHeight } = this.state;
    if (settingsHeight === 0) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }

    this.setState({
      settingsHeight: settingsHeight === 0 ? "auto" : 0,
    });
  };

  onRecentChangesDismiss = () => {
    const { user, isSubUser, subUser, userRecentVersion, dispatch } =
      this.props;
    let currentUser = user;
    if (isSubUser) {
      currentUser = subUser;
    }
    let userIds = [];
    if (userRecentVersion) {
      userIds = (userRecentVersion.userIds || []).slice(0);
    }
    userIds.push(currentUser?.userId);
    // store UserRecentVersion variable for the current user and version
    // dispatch action to update the current user-version object in order to hide the tooltip
    var _userRecentVersion = {
      userIds: userIds,
      currentVersion: window.NTT && window.NTT.version,
    };
    localStorage.setItem(
      "UserRecentVersion",
      JSON.stringify(_userRecentVersion)
    );
    dispatch(userActions.changeUserRecentVersionState(_userRecentVersion));
  };

  handleGoToHelp = (event) => {
    event.preventDefault();
    let { location, isSubUser, isSender, currentLanguage } = this.props;
    var filePath = isSubUser
      ? isSender
        ? `help/${currentLanguage}/sender-guide.html`
        : `help/${currentLanguage}/user-guide.html`
      : `help/${currentLanguage}/ntt-wiki.html`;
    if (location.pathname.startsWith("/files")) {
      window.open(`${filePath}#files`);
    } else if (location.pathname.startsWith("/documents")) {
      window.open(`${filePath}#documents`);
    } else if (location.pathname.startsWith("/exec-reports")) {
      window.open(`${filePath}#exec-reports`);
    } else if (location.pathname.startsWith("/config-reports")) {
      window.open(`${filePath}#config-reports`);
    } else if (location.pathname.startsWith("/customers")) {
      window.open(`${filePath}#customers`);
    } else if (location.pathname.startsWith("/dashboard")) {
      window.open(`${filePath}#dashboard`);
    } else {
      window.open(`${filePath}#files`);
    }
  };

  handleShowSmartSearch = (event) => {
    event.preventDefault();
    window.location.hash = "#/smart-search";
  };

  handlePageSizeChange = (selectedPageItemCount) => {
    const { user, subUser, isSubUser, dispatch } = this.props;
    let currentUser = user;
    if (isSubUser) {
      currentUser = subUser;
    }
    if (currentUser?.pageItemCount !== selectedPageItemCount.value) {
      const defaultSize = selectedPageItemCount.value;
      dispatch(settingActions.changePageItemCount(defaultSize, currentUser));
      dispatch(actions.change("fileSearch.Size", defaultSize));
      dispatch(actions.change("docSearch.Size", defaultSize));
      dispatch(actions.change("execReportSearch.Size", defaultSize));
      dispatch(actions.change("configReportSearch.Size", defaultSize));
      dispatch(documentActions.setDocumentListParams("Size", defaultSize));
    }
  };

  render() {
    const {
      user,
      subUser,
      isSubUser,
      isSender,
      translate,
      location,
      files,
      documents,
      dispatch,
      defaultReportPage,
      userRecentVersion,

      handleLogout,
      tzOptions,
      handleChangeTimeZone,
      handleLanguageChange,
    } = this.props;

    var baseUserId = "",
      currentUser = user,
      loginInternalUser = true;
    const { settingsHeight } = this.state;
    let recentChangesLink = "help/recent-changes-internal.html";
    if (isSubUser) {
      currentUser = subUser;
      if (user?.userId !== subUser?.userId) {
        baseUserId = user?.userId;
      } else {
        loginInternalUser = false;
      }
      recentChangesLink = "help/recent-changes.html";
      if (isSender) {
        recentChangesLink = "help/recent-changes-sender.html";
      }
    }
    const { userId, timeZone, language, pageItemCount } = currentUser || {};

    let showRecentUpdate = true;
    if (
      userRecentVersion &&
      userRecentVersion.userIds &&
      userRecentVersion.userIds.includes(userId) &&
      userRecentVersion.currentVersion === window.NTT.version
    ) {
      showRecentUpdate = false;
    }

    return (
      <>
        <div className="sticky-top d-flex flex-row justify-content-between bordered-panel-div">
          <div className="top" style={{ flex: "1" }}>
            <Navbar
              expand="md"
              className="navbar-light top_menu_custom_styles"
              style={{ padding: 0, alignItems: "flex-end" }}
            >
              <NavbarBrand className="header-title">
                <img
                  className=""
                  id="oc-logo"
                  alt="Posti"
                  src={logo2}
                  style={{ width: "210px", float: "left" }}
                />
                <div className="service-name-text">
                  Track &<br />
                  Trace
                </div>
              </NavbarBrand>
              <Collapse
                className="top_menu_custom_styles"
                //isOpen={this.state.collapsed}
                navbar
              >
                <Nav navbar>
                  {isSubUser && !isSender && (
                    <NavItem className="homeTab">
                      <NavLink
                        to="/home"
                        activeClassName="active"
                        className="nav-link default-top-bar-color w_action_top_menu orange_button"
                        style={{ paddingTop: "8px" }}
                      >
                        <i
                          className="fa fa-home"
                          style={{ fontSize: "1.4em" }}
                        />
                      </NavLink>
                    </NavItem>
                  )}
                  {!isSubUser && (
                    <NavItem className="dashTab">
                      <NavLink
                        to="/dashboard"
                        activeClassName="active"
                        className="nav-link default-top-bar-color w_action_top_menu orange_button"
                      >
                        {translate("Dashboard")}
                      </NavLink>
                    </NavItem>
                  )}
                  {!isSender && (
                    <NavItem className="filesTab">
                      <NavLink
                        to="/files"
                        activeClassName="active"
                        className="nav-link default-top-bar-color w_action_top_menu orange_button"
                      >
                        {translate("Files")}
                      </NavLink>
                    </NavItem>
                  )}
                  <NavItem className="docsTab">
                    <NavLink
                      to="/documents"
                      activeClassName="active"
                      className="nav-link default-top-bar-color w_action_top_menu orange_button"
                    >
                      {translate("Documents")}
                    </NavLink>
                  </NavItem>
                  {!isSender && (
                    <NavItem className="reportsTab">
                      <NavLink
                        to={defaultReportPage}
                        activeClassName="active"
                        className={`nav-link default-top-bar-color w_action_top_menu orange_button ${
                          location.pathname.startsWith("/exec-reports") ||
                          location.pathname.startsWith("/config-reports")
                            ? "active"
                            : ""
                        }`}
                      >
                        {translate("Reports")}
                      </NavLink>
                    </NavItem>
                  )}
                  {!isSubUser && (
                    <UncontrolledDropdown>
                      <DropdownToggle
                        caret
                        nav
                        className={`configTab ${
                          location.pathname.startsWith("/customers")
                            ? "active"
                            : ""
                        }`}
                      >
                        Config{" "}
                      </DropdownToggle>
                      <DropdownMenu right>
                        <DropdownItem
                          tag={NavLink}
                          to="/customers"
                          activeClassName="active"
                          className="nav-link default-top-bar-color w_action_top_menu orange_button"
                        >
                          Customers
                        </DropdownItem>
                        <DropdownItem
                          tag={NavLink}
                          to="/settings"
                          activeClassName="active"
                          className="nav-link default-top-bar-color w_action_top_menu orange_button"
                        >
                          Settings
                        </DropdownItem>
                        <DropdownItem
                          tag={NavLink}
                          to="/uploaddeliverydelaysexcel"
                          activeClassName="active"
                          className="nav-link default-top-bar-color w_action_top_menu orange_button"
                        >
                          Upload excel
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  )}
                  <li className="nav-item d-button-logout">
                    <button
                      className="nav-link default-top-bar-color w_action_top_menu orange_button"
                      style={{ display: "table", width: "100%" }}
                      onClick={() => {
                        handleLogout();
                      }}
                      data-action="logoff"
                    >
                      <div className="but_log_off" translate="LogOff">
                        {translate("LogOff")}
                      </div>
                    </button>
                  </li>
                </Nav>
              </Collapse>
            </Navbar>
          </div>
          <div className="white top d-none d-md-block">
            <Nav
              className="navbar navbar-nav navbar-expand-md navbar-light"
              id="navigationDiv2"
              role="navigation"
              style={{ padding: "20px 8px 0 0" }}
            >
              {(files.downloadLoading || documents.downloadLoading) && (
                <>
                  <Spinner
                    color="info"
                    size="sm"
                    style={{ marginRight: "0.5em" }}
                    data-tip
                    data-place="bottom"
                    data-type="info"
                    data-effect="solid"
                    data-for="DownloadSpinnerTip"
                  />
                  <TooltipWithAutoHide
                    showInitial
                    hideAfter={10000}
                    className="customeTheme"
                    id="DownloadSpinnerTip"
                  >
                    <strong>{translate("FileGettingPrepared")}</strong>
                  </TooltipWithAutoHide>
                </>
              )}
              {(files.emailSent || documents.emailSent) && (
                <>
                  <button
                    className="add-issue-btn"
                    data-tip
                    data-place="bottom"
                    data-type="info"
                    data-effect="solid"
                    data-for="EmailSentBtn"
                    onMouseOver={() => {
                      dispatch(fileActions.setEmailSent(false));
                      dispatch(documentActions.setEmailSent(false));
                    }}
                  >
                    <i
                      className="fa fa-envelope"
                      style={{ padding: "0 10px" }}
                    />
                  </button>
                  <TooltipWithAutoHide
                    showInitial
                    className="customeTheme react-tooltip-clickable-link"
                    id="EmailSentBtn"
                  >
                    <div>{translate("EmailSent")}</div>
                  </TooltipWithAutoHide>
                </>
              )}
              {(files.emailDownloadFileParams ||
                documents.emailDownloadFileParams) && (
                <>
                  <button
                    className="add-issue-btn"
                    data-tip
                    data-place="bottom"
                    data-type="info"
                    data-effect="solid"
                    data-for="DownloadFileBtn"
                    onClick={async () => {
                      try {
                        const params =
                          files.emailDownloadFileParams ||
                          documents.emailDownloadFileParams;
                        const res = await axios.get(
                          "Reporting/Pipelines/DownloadFileDirectly",
                          {
                            params,
                            responseType: "blob",
                          }
                        );
                        var data = new Blob([res.data]);
                        const fileName = params?.FileLocation.replace(
                          // eslint-disable-next-line no-useless-escape
                          /^.*[\\\/]/,
                          ""
                        );
                        FileSaver.saveAs(data, fileName);
                        dispatch(
                          fileActions.setEmailFailedButDownloadReady(null)
                        );
                        dispatch(
                          documentActions.setEmailFailedButDownloadReady(null)
                        );
                      } catch (error) {
                        dispatch(
                          fileActions.setEmailFailedButDownloadReady(null)
                        );
                        dispatch(
                          documentActions.setEmailFailedButDownloadReady(null)
                        );
                        handleErrors(error, dispatch, "Downloading file");
                      }
                    }}
                  >
                    <i
                      className="fa fa-download"
                      style={{ padding: "0 10px" }}
                    />
                  </button>
                  <TooltipWithAutoHide
                    showInitial
                    className="customeTheme react-tooltip-clickable-link"
                    id="DownloadFileBtn"
                  >
                    <div>{translate("EmailSendingFailedMsg")}</div>
                  </TooltipWithAutoHide>
                </>
              )}
              {(files.downloadFileParams || documents.downloadFileParams) && (
                <>
                  <button
                    className="add-issue-btn"
                    data-tip
                    data-place="bottom"
                    data-type="info"
                    data-effect="solid"
                    data-for="DownloadFileBtn"
                    onClick={async () => {
                      try {
                        const params =
                          files.downloadFileParams ||
                          documents.downloadFileParams;
                        const res = await axios.get(
                          "Reporting/Pipelines/DownloadFileDirectly",
                          {
                            params,
                            responseType: "blob",
                          }
                        );
                        var data = new Blob([res.data]);
                        const fileName = params?.FileLocation.replace(
                          // eslint-disable-next-line no-useless-escape
                          /^.*[\\\/]/,
                          ""
                        );
                        FileSaver.saveAs(data, fileName);
                        dispatch(fileActions.setDownloadFileParams(null));
                        dispatch(documentActions.setDownloadFileParams(null));
                      } catch (error) {
                        dispatch(fileActions.setDownloadFileParams(null));
                        dispatch(documentActions.setDownloadFileParams(null));
                        handleErrors(error, dispatch, "Downloading file");
                      }
                    }}
                  >
                    <i className="fa fa-save" style={{ padding: "0 10px" }} />
                  </button>
                  <TooltipWithAutoHide
                    showInitial
                    className="customeTheme react-tooltip-clickable-link"
                    id="DownloadFileBtn"
                  >
                    <div>{translate("FileReadyDownloadMsg")}</div>
                  </TooltipWithAutoHide>
                </>
              )}
              {!isSubUser && (
                <>
                  <button
                    className="smart-search-btn"
                    data-tip
                    data-place="bottom"
                    data-type="info"
                    data-effect="solid"
                    data-for="SmartSearchTip"
                    onClick={(e) => {
                      this.handleShowSmartSearch(e);
                    }}
                  >
                    <i className="fa fa-search" style={{ padding: "0 10px" }} />
                  </button>
                  <ReactTooltip id="SmartSearchTip" className="customeTheme">
                    <strong>{translate("Search")}</strong>
                  </ReactTooltip>
                </>
              )}
              {isSubUser && loginInternalUser && (
                <li className="nav-item w_user_console w_user_1">
                  <button className="nav-link default-top-bar-color w_value_suserId disabled">
                    {baseUserId}
                  </button>
                </li>
              )}
              <li
                className="nav-item w_user_console w_user_2"
                hidden={!loginInternalUser}
              >
                <SwitchUserButton />
              </li>
              <li className="nav-item w_user_3">
                <button className="nav-link default-top-bar-color w_user_console disabled">
                  {userId}
                </button>
              </li>
              {!isSubUser && (
                <AddIssueButton
                  user={user}
                  subUser={subUser}
                  isSubUser={isSubUser}
                  location={location}
                />
              )}
              <button
                className="tooltip-btn"
                data-tip
                data-place="bottom"
                data-type="info"
                data-effect="solid"
                data-for="RecentChangesTip"
                onClick={(e) => {
                  this.handleGoToHelp(e);
                }}
              >
                <i
                  className="fa fa-question-circle"
                  style={{ padding: "0 10px" }}
                />
              </button>
              {showRecentUpdate && (
                <div className="recent-changes-alert">
                  {translate("Portal recently updated")} —{"  "}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={recentChangesLink}
                    className="alert-link"
                  >
                    {translate("Read more")}
                  </a>
                  <button
                    type="button"
                    className="close"
                    aria-label="Close"
                    style={{ backgroundColor: "transparent" }}
                    onClick={this.onRecentChangesDismiss}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
              )}
              <button
                className="w_action_top_menu nav-hearder-button w_user_4 w_user_settings_icon"
                onClick={this.toggleSettings}
                style={{ fontSize: "14pt" }}
              >
                <span
                  className="fa fa-cog"
                  style={{ padding: "0 10px" }}
                  aria-hidden="true"
                />
              </button>
              <li className="nav-item logoutTab">
                <button
                  onClick={() => {
                    handleLogout();
                  }}
                  className="nav-link default-top-bar-color w_action_top_menu"
                  data-action="logoff"
                >
                  <span>{translate("LogOff")}</span>
                </button>
              </li>
            </Nav>
          </div>
          <div className="ls-screen-hidden top">
            <Nav
              className="navbar navbar-nav navbar-custom-sm-screen navbar-light"
              id="navigationDiv2-small"
              role="navigation"
              style={{ padding: "30px 20px 0 0" }}
            >
              <li className="nav-item w_user_3">
                <button className="nav-link default-top-bar-color w_user_console disabled">
                  {userId}
                </button>
              </li>
            </Nav>
          </div>
        </div>
        <AnimateHeight
          className="settings-panel"
          duration={500}
          height={settingsHeight}
        >
          <div
            ref={(settingsNode) => {
              this.settingsContainerNode = settingsNode;
            }}
            className="bordered-panel-div2"
          >
            <div
              className="text-center"
              style={{ fontWeight: "600", paddingTop: ".1rem" }}
            >
              {translate("Settings")}:
            </div>
            <div
              className="text-right w_userId"
              style={{ fontWeight: "400", fontSize: "12px" }}
            >
              <span style={{ fontWeight: "600" }}>{translate("User")}: </span>
              {userId}
            </div>
            <div className="w_settings">
              <div className="row">
                <div className="text-left col-4">
                  <span style={{ lineHeight: "1.5rem" }}>
                    {translate("TimeZone")}
                  </span>
                </div>
                <div className="col-8" style={{ paddingBottom: ".4rem" }}>
                  <Select
                    name="timeZoneId"
                    clearable={false}
                    value={timeZone}
                    onChange={handleChangeTimeZone}
                    options={tzOptions}
                  />
                </div>
                <div className="text-left col-4">
                  <span style={{ lineHeight: "1.5rem" }}>
                    {translate("Language")}
                  </span>
                </div>
                <div className="col-8" style={{ paddingBottom: ".4rem" }}>
                  <Select
                    name="languageId"
                    clearable={false}
                    value={language}
                    onChange={handleLanguageChange}
                    options={[
                      { value: "en-GB", label: "English (UK)" },
                      { value: "fi", label: "Finnish" },
                      { value: "no", label: "Norwegian" },
                      { value: "sv", label: "Swedish" },
                    ]}
                  />
                </div>
                <div className="text-left col-4">
                  <span style={{ lineHeight: "1.5rem" }}>
                    {translate("RowsPerPage")}
                  </span>
                </div>
                <div className="col-8" style={{ paddingBottom: ".4rem" }}>
                  <Select
                    name="pageItemCount"
                    clearable={false}
                    value={pageItemCount}
                    onChange={this.handlePageSizeChange}
                    options={[
                      { value: 10, label: "10" },
                      { value: 20, label: "20" },
                      { value: 40, label: "40" },
                      { value: 50, label: "50" },
                      { value: 100, label: "100" },
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </AnimateHeight>
      </>
    );
  }
}

function mapStateToProps(state) {
  const {
    files,
    documents,
    reports: { defaultReportPage },
    locale,
    authentication: { user, subUser, isSubUser, userRecentVersion, isSender },
  } = state;

  return {
    user,
    subUser,
    isSubUser,
    isSender,
    files,
    documents,
    userRecentVersion,
    defaultReportPage,
    translate: getTranslate(locale),
    currentLanguage: getActiveLanguage(locale).code,
  };
}

const connectedTopbar = connect(mapStateToProps)(withRouter(Topbar));
export { connectedTopbar as Topbar };
